import { useMediaQuery, useTheme } from '@mui/material'

export const useIsMd = () => {
  const theme = useTheme()
  const isMd = useMediaQuery(theme.breakpoints.up('md'))

  return isMd
}
